import React from 'react';
import { ThemeStyles, Box } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
var themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Wrapper')(css({
    display: 'inline-flex',
    flexWrap: 'nowrap',
}));
var Wrapper = themeStyles.apply(Box, 'Wrapper');
var InlineTextAndTooltip = function (_a) {
    var text = _a.text, children = _a.children;
    var isMultiword = text.trim().split(' ').length > 1;
    /** Basically, the tooltip will be added to the end of the word irrespective of its length, ensuring
        the tooltip is wrapped along with the text if the label is too long and renders in 2 lines or so.
         - Checks if the text contains multiple words and splits the text accordingly.
         - Wraps the last word in a styled 'Wrapper' component and appends children (tooltip).
         - If the text is a single word, it displays the text and children inline. */
    if (isMultiword) {
        var lastWhitespaceIndex = text.lastIndexOf(' ');
        var textHead = text.substring(0, lastWhitespaceIndex + 1);
        var textTail = text.substring(lastWhitespaceIndex + 1);
        return (React.createElement(React.Fragment, null,
            textHead,
            React.createElement(Wrapper, null,
                textTail,
                children)));
    }
    return (React.createElement(React.Fragment, null,
        text,
        children));
};
export default InlineTextAndTooltip;
